import { clsx } from 'clsx';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'primary-inverse' | 'secondary' | 'outline' | 'ghost' | 'danger';
type Size = 'md' | 'sm';

export interface PillButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  loading?: boolean;
  children: ReactNode;
}

const variantClass: Record<Variant, string> = {
  primary: 'pill-primary',
  'primary-inverse': 'pill-primary-inverse',
  secondary: 'pill-secondary',
  outline: 'pill-outline',
  ghost: 'pill-ghost',
  danger: 'pill-danger',
};

const sizeClass: Record<Size, string> = {
  md: '',
  sm: 'min-h-[36px] py-1.5 px-4 text-caption',
};

export function PillButton({
  variant = 'primary',
  size = 'md',
  loading,
  className,
  disabled,
  children,
  ...rest
}: PillButtonProps) {
  return (
    <button
      {...rest}
      disabled={disabled || loading}
      className={clsx(
        variantClass[variant],
        sizeClass[size],
        (disabled || loading) && 'opacity-60 cursor-not-allowed',
        className
      )}
    >
      {loading ? <Spinner /> : children}
    </button>
  );
}

function Spinner() {
  return (
    <span className="inline-flex items-center gap-2" aria-live="polite">
      <span className="h-2 w-2 rounded-full bg-current animate-pulse-soft" />
      <span>Working…</span>
    </span>
  );
}
